export default defineNuxtPlugin((nuxtApp) => {
  // Get localized path for homepage
  const localePath = nuxtApp.$localePath('index')
  // Get path to switch current route to French
  const switchLocalePath = nuxtApp.$switchLocalePath('fr')
});